import React from 'react'
import { useTimeTravel } from '@fs/zion-rootstech'
import { Badge } from './Badge'
import { hour } from '../config'
import { MonoText } from './type'

export default function Classroom({ classroom, date, sessionLocation }) {
  const { getNow } = useTimeTravel()
  const isInPerson = sessionLocation?.includes('In Person')
  const currentDate = new Date(getNow())
  const hourPastStartTime = date + 1 * hour

  return classroom && currentDate <= hourPastStartTime && isInPerson ? (
    <Badge
      data-testid={`item-${classroom}`}
      flavor="flavorless"
      keyline="left"
      label={<MonoText>{classroom} </MonoText>}
    />
  ) : null
}
